"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LDS_API_URL = 'https://lds.ropto.com/leads/';
var DEV_MODE = 'development';

var _default = function _default(leadData, sessionData) {
  var devMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var submitUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return new Promise(function (resolve, reject) {
    var body = _objectSpread(_objectSpread({}, sessionData), leadData);

    if (process.env.NODE_ENV === DEV_MODE || devMode) {
      // eslint-disable-next-line no-console
      console.log({
        message: 'Not submitting lead in development mode',
        NODE_ENV: process.env.NODE_ENV,
        leadData: body
      }); // Mock resolved response to match fetch signature

      resolve({
        json: function json() {
          return Promise.resolve({
            leadId: 'test'
          });
        }
      });
    } else {
      var fetchResponse = {};
      fetch(submitUrl || LDS_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (!response) {
          return reject(new Error('Failed to submit lead: no response received'));
        }

        fetchResponse = _objectSpread({}, response);

        if (response.status < 200 || response.status >= 300) {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(fetchResponse));
          return reject(new Error('Failed to submit lead: status code not in 2xx range'));
        }

        return resolve(response);
      })["catch"](function (error) {
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(fetchResponse));
        reject(new Error("Failed to submit lead: ".concat(error)));
      });
    }
  });
};

exports["default"] = _default;